import { useTranslation } from 'react-i18next'

import { Alert } from '@reveni-io/reveni-ui'

import { getImportFileErrorCopy } from '../helpers'

const ImportFileErrorAlert = ({ fileError }) => {
  const { t } = useTranslation()
  const { key, params } = getImportFileErrorCopy(fileError)

  return <Alert type="error">{t(key, params)}</Alert>
}

export default ImportFileErrorAlert
